<template>
  <div class="bg-white/90">
    <div class="flex flex-col gap-3">
      <AdminHeader />

      <div class="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
        <div
          class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
        >
          <div class="flex items-center gap-3">
            <div
              class="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-md"
            >
              <svg
                class="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                ></path>
              </svg>
            </div>
            <div>
              <h1
                class="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent"
              >
                Student Dashboard
              </h1>
              <p class="text-sm text-gray-500 mt-0.5">
                Welcome back! Track your learning progress
              </p>
            </div>
          </div>
          <router-link
            :to="{ name: 'StudentList' }"
            @click.native="clearStudentStore"
            class="group relative inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 px-5 py-2.5 rounded-xl text-sm font-semibold cursor-pointer hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 text-white shadow-md hover:shadow-lg overflow-hidden"
          >
            <span
              class="absolute inset-0 bg-white/20 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300"
            ></span>

            <svg
              class="w-4 h-4 relative z-10 group-hover:-translate-x-1 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              ></path>
            </svg>

            <span class="relative z-10">Back </span>

            <span
              class="absolute -top-1 -right-1 w-2 h-2 bg-green-400 rounded-full animate-pulse"
            ></span>
          </router-link>
        </div>
      </div>
      <Header />
    </div>
    <router-view />
  </div>
</template>

<script>
import AdminHeader from "@/components/Admin/Header.vue";
import Header from "@/components/Student_preview/Header.vue";
import { mapGetters } from "vuex";
export default {
  name: "Dashboard",
  components: {
    Header,
    AdminHeader,
  },
  props: ["course_id"],
 methods: {
    clearStudentStore() {
      this.$store.dispatch("student/clearStudentData");
    }
  },
  computed: {
    ...mapGetters("student", [
      "studentdata"]),
  },
  created(){

  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("student/clearStudentData");
   localStorage.removeItem("previewIgnoreList");
    next();
  }
};
</script>
